class Account {
    constructor() {
        this.header = $('.header');
        this.accountNav = $('.account__nav');
        this.accountPlaceholder = $('.account__nav-placeholder');
        this.accountNavList = $('.account__navlist');
        this.events();
    }

    events() {

        this.accountPlaceholder.on('click', e => {
            e.stopPropagation();
            if (!this.isAccountActive()) {
                this.openAccountMenu();
            } else {
                this.closeAccountMenu();
            }
        })

        //close account when click on body;
        $('body').on('click', () => {
            this.closeAccountMenu();
        })
    }

    //open search field
    openAccountMenu() {
        this.accountPlaceholder.addClass('account__nav-placeholder--active')
        this.accountNavList.addClass('account__navlist--active')
    }

    //close search field
    closeAccountMenu() {
        this.accountPlaceholder.removeClass('account__nav-placeholder--active')
        this.accountNavList.removeClass('account__navlist--active')
    }


    //check if search bar is active;
    isAccountActive() {
        return this.accountNavList.hasClass('account__navlist--active');
    }

}

export default Account;